import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import ForwardIcon from '@material-ui/icons/Forward';
import LockIcon from '@material-ui/icons/Lock';
import { globalData, ADD, EDIT, VIEW, DRAFT, MANUAL, EMAIL } from '../../../common/common';

const Root = styled(Box)({
    width: '100%',
    maxHeight: '650px',
    overflowX: 'auto',
    '& .wapper': {
        padding: '10px 15px',
        cursor: 'pointer',
        '& .icon': {
            visibility: 'hidden',
        },
        '& .lockIcon': {
            width: '15px',
            marginRight: '5px',
        },
    },
    '& .wapper:hover': {
        backgroundColor: '#009CEE',
        color: '#fff',
        '& .icon': {
            visibility: 'visible',
            color: '#fff',
        },
        '& .lockIcon': {
            width: '15px',
            marginRight: '5px',
            color: '#fff',
        },
    },
    '& .wapper-disable': {
        padding: '10px 15px',
        opacity: '0.3',
        '& .icon': {
            display: 'none',
        },
    },
    '& .wapperSelect': {
        padding: '10px 15px',
        cursor: 'pointer',
        backgroundColor: '#009CEE',
        color: '#fff',
        '& .icon': {
            visibility: 'visible',
            color: '#fff',
        },
        '& .lockIcon': {
            width: '15px',
            marginRight: '5px',
            color: '#fff',
        },
    },
    '& .input-hidden': {
        visibility: 'hidden'
    },
})

class EstateMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sendEmail: "",
            btnName: this.btnName(this.props.state)
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    render() {
        const { menuData, menuIndex } = this.props;
        const menuView = (row, index) => {
            if (index === 9 || index === 10 || index === 17 || index === 18) return;
            return <div key={index} className={`${this.inputClass1(menuIndex, index)} ${this.inputClass2(index)}`} onClick={e => this.handleClick(e, index)}>
                <div className='f'>
                    <div className="h">
                        {lockView(index)}
                        {row}
                    </div>
                </div>
                <ForwardIcon className='icon'></ForwardIcon>
            </div>
        }
        const lockView = (index) => {
            if (index === 5 || index === 13 || index === 22) {
                if (globalData.haveNonage === false) {
                    return <LockIcon className="lockIcon" />
                }
            }
        }
        return (
            <Root>
                {menuData.map((row, index) => (
                    menuView(row, index)
                ))}
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    componentDidUpdate(prevProps) {
        const { sendEmail } = this.props;
        if (sendEmail !== prevProps.sendEmail) {
            this.setState(() => ({
                sendEmail,
            }));
        }
    }
    initData() {
        const { sendEmail } = this.props;
        this.setState(() => ({
            sendEmail,
        }));
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleClick(e, index) {
        const { isLock } = this.props;
        const disable = this.disableMenu(index);
        if (!isLock && disable === false) this.props.handleMenuIndex(index);
    }
    disableMenu(index) {
        const { epStatus } = this.props;
        if (epStatus === DRAFT && index === 1) {
            return true;
        } else {
            return false;
        }
    }
    inputClass1(menuIndex, index) {
        if (this.disableMenu(index)) {
            return "wapper-disable";
        } else {
            return menuIndex === index ? "wapperSelect h" : "wapper h";
        }
    }
    inputClass2(index) {
        const { sendEmail } = this.state;
        const { state, enduserFilled, epStatus } = this.props;
        if (enduserFilled && sendEmail) return "";
        if (sendEmail || state === ADD) {
            if (index > 1) {
                return "input-hidden";
            }
        } else {
            return "";
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default EstateMenu;